export default "__VITE_ASSET__HIf34heY__"